import { alertOpen, AlertValue } from "../features/alert.slice";
import { auth } from "../firebase";
import companiesQuery from "../firestore/Companies.query";
import { OptionContract } from "../model/OptionContract";

// オプション設定チェック（ボタン押下時用）
export const checkOption = async (
  option: string,
  dispatch: any,
  showAlert: boolean = true
): Promise<boolean> => {
  try {
    const options = await companiesQuery.getOptionContractList(auth.currentUser?.tenantId!);
    const targetOption = options.find((opt) => opt.optionId === option);
    const isActive = targetOption ? isOptionActive(targetOption) : false;

    if (!isActive && showAlert) {
      const msg = {
        point: "ポイント管理のオプションが無効のため操作できません。運営者に問い合わせてください。",
        userIdCard: "利用者IDカードのオプションが無効のため操作できません。運営者に問い合わせてください。",
        attendance: "出欠管理（二次元コード）のオプションが無効のため操作できません。運営者に問い合わせてください。"
      }[option];
      dispatch(alertOpen(AlertValue(msg ?? "オプションが無効のため操作できません。運営者に問い合わせてください。", "danger")));
    }

    return isActive;
  } catch (e) {
    console.error(e);
    if (showAlert) {
      dispatch(alertOpen(AlertValue("オプション確認に失敗しました。", "danger")));
    }
    return false;
  }
};

// オプションの期間チェック
export const isOptionActive = (option: OptionContract): boolean => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const {
    status,
    applicableStartDate: start,
    applicableFinishDate: finish,
  } = option;
  if (status !== true) return false;
  const startDate = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : null;
  const finishDate = finish ? new Date(finish.getFullYear(), finish.getMonth(), finish.getDate()) : null;

  return (
    (startDate !== null && finishDate !== null && startDate <= today && finishDate >= today && startDate <= finishDate) || // 期間中
    (startDate === null && finishDate === null) ||                                                                           // 無期限
    (startDate !== null && finishDate === null && startDate <= today) ||                                                    // 終了日なし・開始済み
    (startDate === null && finishDate !== null && finishDate >= today) 
  );
};